/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown>, planned: NonNullable<unknown> }} Progress_Report_Consistency_WeekInputs */

const en_us2_progress_report_consistency_week = /** @type {(inputs: Progress_Report_Consistency_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} of 1 planned workout`);
	return /** @type {LocalizedString} */ (`${i?.done} of ${i?.planned} planned workouts`)
	
};

const pt_br2_progress_report_consistency_week = /** @type {(inputs: Progress_Report_Consistency_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 treino planejado`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.planned} treinos planejados`)
	
};

const es_419_progress_report_consistency_week = /** @type {(inputs: Progress_Report_Consistency_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 entrenamiento planeado`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.planned} entrenamientos planeados`)
	
};

const pt_pt2_progress_report_consistency_week = /** @type {(inputs: Progress_Report_Consistency_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 treino planeado`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.planned} treinos planeados`)
	
};

const fr_fr2_progress_report_consistency_week = /** @type {(inputs: Progress_Report_Consistency_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} sur 1 séance prévue`);
	return /** @type {LocalizedString} */ (`${i?.done} sur ${i?.planned} séances prévues`)
	
};

const de_de2_progress_report_consistency_week = /** @type {(inputs: Progress_Report_Consistency_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} von 1 geplanten Training`);
	return /** @type {LocalizedString} */ (`${i?.done} von ${i?.planned} geplanten Trainings`)
	
};

const it_it2_progress_report_consistency_week = /** @type {(inputs: Progress_Report_Consistency_WeekInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} di 1 allenamento previsto`);
	return /** @type {LocalizedString} */ (`${i?.done} di ${i?.planned} allenamenti previsti`)
	
};

/**
* | planned | output |
* | --- | --- |
* | "1" | "{done} of 1 planned workout" |
* | * | "{done} of {planned} planned workouts" |
*
* @param {Progress_Report_Consistency_WeekInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_consistency_week = /** @type {((inputs: Progress_Report_Consistency_WeekInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Consistency_WeekInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_consistency_week(inputs)
	if (locale === "es-419") return es_419_progress_report_consistency_week(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_consistency_week(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_consistency_week(inputs)
	if (locale === "de-DE") return de_de2_progress_report_consistency_week(inputs)
	if (locale === "it-IT") return it_it2_progress_report_consistency_week(inputs)
	return en_us2_progress_report_consistency_week(inputs)
});
export { progress_report_consistency_week as "progress-report.consistency_week" }